var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFuriaTravel = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 92,
    viewBox: "0 0 91 92",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "furia-travel-a",
    points: ".142 .056 16.401 .056 16.401 50.886 .142 50.886"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "furia-travel-c",
    points: "0 65.676 36.081 65.676 36.081 .152 0 .152"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "furia-travel-e",
    cx: "68.525%",
    cy: "50.022%",
    r: "38.595%",
    fx: "68.525%",
    fy: "50.022%",
    gradientTransform: "matrix(1 0 0 .98889 0 .006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EADFDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "90.68%",
    stopColor: "#D9DDE6",
    stopOpacity: 0.862
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EAF0F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "furia-travel-f",
    cx: "19%",
    cy: "71.793%",
    r: "82.954%",
    fx: "19%",
    fy: "71.793%",
    gradientTransform: "matrix(1 0 0 .98889 0 .008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0.494
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "3.069%",
    stopColor: "#DDE8ED",
    stopOpacity: 0.615
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99.93%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "furia-travel-g",
    cx: "79.211%",
    cy: "12.912%",
    r: "84.946%",
    fx: "79.211%",
    fy: "12.912%",
    gradientTransform: "matrix(1 0 0 .98889 0 .001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C6D3DA",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DCE7FC",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.726,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.06 14.595)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BD3339",
    d: "M32.0443478,22.9030647 L34.4477811,41.5162106 L32.1993717,49.9013794 C32.1993717,49.9013794 20.8493257,48.5272144 17.0788019,48.5631222 C12.9316307,48.6024827 1.47808535,49.8486686 1.47808535,49.8486686 L1.33633634,22.9030647 L32.0443478,22.9030647 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "28.212 34.885 26.091 34.985 17.892 35.368 9.693 34.985 7.573 34.885 8.432 37.597 9.641 43.542 10.273 43.684 11.481 47.466 10.192 51.45 9.752 52.811 8.647 56.229 9.666 62.035 16.753 62.035 17.419 60.393 18.181 60.393 19.01 62.035 19.121 62.035 26.118 62.035 27.137 56.228 26.032 52.811 25.592 51.45 24.304 47.466 25.512 43.683 26.137 43.542 27.348 37.587"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BD3339",
    points: "8.914 43.812 12.237 44.138 14.403 42.166 12.185 43.867 8.166 42.761 8.286 43.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BD3339",
    points: "24.197 43.812 20.875 44.138 18.709 42.166 20.927 43.867 24.945 42.761 24.825 43.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BD3339",
    points: "17.488 43.59 18.709 37.616 17.075 43.683"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DB3D35",
    points: "18.266 34.282 18.261 34.28 18.261 34.275"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DB3D35",
    points: "17.518 39.281 17.523 39.288 17.518 39.286"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DB3D35",
    points: "3.858 34.282 3.862 34.275 3.863 34.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DB3D35",
    points: "4.605 39.281 4.605 39.286 4.601 39.288"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "18.173 60.215 18.115 60.215 18.947 61.884 19.006 61.884"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C2C2C",
    d: "M5.45422817,44.8467828 L3.73942621,45.1015274 L6.42218164,43.0794779 L8.41730508,37.5933631 L9.62797868,43.5304103 L10.2606722,43.6721913 L11.4706703,47.448405 L12.427591,50.3647118 L5.45422817,44.8467828 Z M9.71196255,61.8837775 L8.69109699,56.0887418 L10.4018461,50.8179496 L25.4408124,50.8179496 L24.3134472,47.3951507 L25.5236705,43.6442962 L26.1500595,43.5172697 L27.3627595,37.5769949 L29.3617107,43.0760198 L32.0446912,45.0999136 L30.3298893,44.8458606 L23.6647675,50.3301311 L23.9390097,51.7018326 L34.1508175,45.380709 L31.7267684,39.7507385 L28.2273656,34.8854628 L26.1034518,34.9845942 L17.891721,35.367518 L9.68044045,34.9845942 L7.55652674,34.8854628 L4.0571239,39.750969 L1.63329997,45.380709 L12.2179691,51.8931792 L8.63278112,56.1419961 L9.65342151,61.8837775 L14.3855634,61.8837775 L9.71196255,61.8837775 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD6A6",
    d: "M15.4825531 49.9660709C17.0510075 50.4714602 18.0719974 51.7009101 17.7625316 52.7123806 17.4532905 53.7238511 15.9309076 54.1339753 14.3624532 53.6285861 12.7937741 53.1231968 11.773009 51.8935162 12.08225 50.8822764 12.3917158 49.8708059 13.9140987 49.4606817 15.4825531 49.9660709M20.4149359 49.9902171C18.8502288 50.5214959 17.8484374 51.7612992 18.1772559 52.759508 18.5058489 53.7574878 20.0407864 54.1357949 21.6054935 53.6042871 23.169975 53.0730083 24.1717664 51.833205 23.8431734 50.8352252 23.5143549 49.8372454 21.9796429 49.4589383 20.4149359 49.9902171"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "17.521 60.391 8.867 61.549 9.772 61.967 15.093 63.445 9.134 64.462 2.821 63.432 4.021 59.951 8.552 56.272"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "4.029 61.641 20.833 60.193 21.084 62.36 6.119 65.676 2.821 63.557 4.023 60.064"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C2C2C",
    d: "M4.00900901,61.5804257 L20.7874541,60.0636664"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "4.306 62.072 6.126 61.85 20.834 60.661 21.033 62.339 21.084 62.328 20.834 60.215 6.126 61.404"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "18.115 60.391 26.769 61.549 25.864 61.967 19.684 63.4 26.502 64.462 32.814 63.432 31.615 59.951 27.083 56.272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEBEB",
    d: "M18.5518732,62.4904812 L25.3877857,61.502519 C25.3877857,61.502519 27.6622209,60.4953375 25.4904426,58.850259 L20.5602109,59.412194 L18.2632633,60.4482045 L18.5518732,62.4904812 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "23.164 61.732 23.46 61.677 23.163 59.76 22.866 59.816"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "24.203 61.58 24.499 61.525 24.202 59.609 23.906 59.664"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "25.094 61.429 25.39 61.373 25.093 59.457 24.796 59.513"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "31.605 61.641 15.876 60.27 14.551 62.565 29.511 65.676 32.814 63.557 31.611 60.064"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "15.878 60.919 30.947 62.088 31.181 61.62 15.878 60.215 14.551 62.567 14.906 62.642"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2B99A",
    d: "M4.30597264,17.5944073 C3.06539982,17.691178 2.07874541,18.7751003 2.07874541,20.089625 L2.07874541,24.3514211 C2.07874541,25.6659458 3.06539982,26.7498682 4.30597264,26.8466388 L4.30597264,17.5944073 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M2.67267267,13.6508333 C2.67267267,13.6508333 -0.466006335,45.7704438 0.471924541,48.0812683 L2.67267267,36.4101448 L2.67267267,13.6508333 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M4.8998999,13.9376509 C4.8998999,12.872289 3.43094409,12.7019322 3.20321614,13.7406256 C1.8708971,19.819442 0.352415989,28.0246142 1.07937666,31.0935647 C1.07937666,31.0935647 1.56689135,16.023774 4.3591013,14.7646054 C4.68145795,14.6193078 4.8998999,14.3031938 4.8998999,13.9376509 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M6.23623624,4.85362961 C2.90910102,5.37964884 0.633208283,22.0830018 0.29696363,27.1499906 C0.29696363,27.1499906 2.91337436,11.5612372 5.12134343,12.4361726 L6.23623624,4.85362961 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2B99A",
    d: "M17.8918339,1.66843518 C10.763058,1.66843518 4.92312828,6.81479502 4.3573703,13.3578403 L4.31612181,13.3578403 L4.31612181,13.3658764 L4.35646869,13.3658764 C4.35353847,13.3987099 4.34880504,13.4310842 4.34632562,13.4639177 L4.31612181,13.4641473 L4.31612181,13.4841229 L4.31612181,29.5344101 C4.31612181,29.5344101 3.86238841,31.4279601 9.02250693,34.0879306 L15.4302232,37.5593241 C15.4302232,37.5593241 17.8118164,38.8219204 20.5903417,37.3790844 L28.869342,32.8255639 C28.869342,32.8255639 31.1812861,31.9620207 31.4486123,29.501347 L31.4776892,29.478157 L31.4776892,29.128469 L31.4776892,13.4641473 L31.4776892,13.3938882 C31.4781448,13.3844744 31.4785908,13.3750606 31.4776892,13.3658764 L31.4776892,13.3578403 C30.9119312,6.81456542 25.0206099,1.66843518 17.8918339,1.66843518"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2B99A",
    d: "M31.4781448,17.5944073 C32.7187176,17.691178 33.705372,18.7751003 33.705372,20.089625 L33.705372,24.3514211 C33.705372,25.6659458 32.7187176,26.7498682 31.4781448,26.8466388 L31.4781448,17.5944073 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.485)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "furia-travel-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#furia-travel-a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M0.163889143,19.8276003 L0.141763318,19.6862152 L0.157793252,20.1253136 C0.115347793,22.0950493 0.168404617,24.1165112 0.296418316,26.1476287 C0.338412227,26.8150122 0.39079173,27.4833154 0.447912481,28.1509289 L0.141763318,50.8863407 L2.89168721,48.8828106 C0.794023592,-7.70272012 16.0554239,9.5503987 16.0554239,9.5503987 L16.4013092,1.10591569 C4.24587798,-3.68715373 0.454911466,8.86807197 0.163889143,19.8276003",
    mask: "url(#furia-travel-b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M34.8813132 21.6265369L34.9522988 19.6557634 34.8689581 20.1921611C34.6488131 9.06931667 30.0693467-3.39578556 18.570362 1.08951025L17.5208542 9.52760938C17.5208542 9.52760938 34.5877116-5.72722049 31.5429708 47.7466943 31.5429708 47.7466943 31.6278838 48.9940775 31.7190868 48.6802791L31.9823623 51.8731665 35.1901902 47.4620704 34.7094653 26.3959971C34.8152697 24.7946144 34.8765958 23.1982856 34.8813132 21.6265369M16.6299633 8.16024134C16.6299633 8.16024134 2.09588841 1.52859677 4.0388281 31.3969165 4.0388281 31.3969165-.828466368-.484384444 16.6299633 8.16024134"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M19.7480814,3.83054723 C19.7480814,3.83054723 34.4899459,5.02900195 32.2820977,32.9136758 C32.2820977,32.9136758 38.9708967,-0.211741134 19.7480814,3.83054723"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M24.2025359 5.45567586C24.2025359 5.45567586 33.056406 12.7978971 31.1836067 31.3969165 31.1836067 31.3969165 35.7435544 3.0311489 24.2025359 5.45567586M33.4084084 11.3756944C33.4084084 11.3756944 36.7713585 36.3382285 35.9526322 47.4745646 35.9526322 47.4745646 33.1404162 12.4379592 33.4526578 12.0915984 33.7651262 11.7450082 33.4084084 11.3756944 33.4084084 11.3756944"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M33.2599266 9.70725922C33.2599266 9.70725922 36.9179824 34.0089317 35.6749053 39.1323887 35.6749053 39.1323887 35.4985534 19.1133041 33.2599266 18.5043988L33.2599266 9.70725922zM18.2289192 31.1097307C18.1754477 31.1344595 18.0346619 31.2206573 17.9662996 31.2625787 17.8981629 31.2206573 17.7571516 31.1344595 17.7036801 31.1097307 17.3697652 30.955234 16.6299633 31.958991 16.6299633 31.958991 17.5466499 32.0991214 17.8627409 31.6996911 17.9662996 31.5320057 18.070084 31.6996911 18.3859494 32.1153718 19.302636 31.9752414 19.302636 31.9752414 18.562834 30.955234 18.2289192 31.1097307"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M16.6299633,31.9777444 C16.6299633,31.9777444 17.9019985,33.3901155 19.302636,31.9940492 L17.9662996,31.3969165 L16.6299633,31.9777444 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.3420087 21.9100465C20.3420087 21.9100465 22.631498 20.1197702 26.8454172 21.8254111 26.8454172 21.8254111 27.7627865 22.1911811 28.1923608 22.448037 28.3544346 22.4044713 27.4665129 21.9141307 26.4001076 21.2717642 26.4001076 21.2717642 22.4972982 19.1118606 20.3420087 21.9100465M15.1451451 21.9100465C15.1451451 21.9100465 12.8556558 20.1197702 8.6417366 21.8254111 8.6417366 21.8254111 7.72436734 22.1911811 7.29479305 22.448037 7.13271923 22.4044713 8.02064097 21.9141307 9.08704621 21.2717642 9.08704621 21.2717642 12.9898556 19.1118606 15.1451451 21.9100465"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DB3D35",
    points: "15.442 .91 20.342 .91 17.54 9.556 17.141 8.341"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEBEB",
    d: "M15.721582,62.945509 L9.53670078,61.9863993 C9.53670078,61.9863993 7.58755217,60.8641109 9.86643118,58.850259 L14.2662359,59.4581749 L16.3329997,60.2633907 L15.721582,62.945509 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "10.25 43.812 13.573 44.138 15.739 42.166 13.521 43.867 9.503 42.761 9.623 43.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "25.534 43.812 22.211 44.138 20.045 42.166 22.263 43.867 26.281 42.761 26.161 43.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "26.248 43.59 27.469 37.616 25.836 43.683"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "9.536 43.59 8.315 37.616 9.948 43.683"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "11.452 47.475 24.301 47.475 24.648 48.536 11.136 48.517"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "10.245 61.353 10.556 61.429 10.988 59.533 10.677 59.457"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "11.136 61.504 11.447 61.58 11.879 59.685 11.568 59.609"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "12.027 61.808 12.338 61.884 12.769 59.988 12.459 59.912"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C2C2C",
    d: "M18.8606265,32.1552962 C18.8176772,32.1552962 18.7003643,32.2299992 18.6613418,32.2398128 C18.8304393,32.2828722 19.0572115,32.2688528 19.0572115,32.4208626 C19.0572115,32.5730726 18.7293244,32.4527065 18.5602269,32.4955656 C18.5992494,32.5055794 18.8883594,32.6103239 18.9313087,32.6103239 C19.1607806,32.6103239 19.302636,32.6081209 19.302636,32.4208626 C19.302636,32.2336042 19.0900984,32.1552962 18.8606265,32.1552962"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004256",
    d: "M32.0720721,27.3016666 L32.0720721,27.3016666 L32.0720721,15.6226203 L32.0720721,15.6226203 C30.923986,15.6226203 29.9933267,16.5639818 29.9933267,17.7249866 L29.9933267,25.1995302 C29.9933267,26.3605351 30.923986,27.3016666 32.0720721,27.3016666"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF7FD",
    d: "M32.9427852,15.8137445 C33.3154154,15.9811795 33.5568902,16.3654978 33.5568902,16.7905249 L33.5568902,21.4621434 L33.5568902,26.1337619 C33.5568902,26.5587891 33.3154154,26.9428774 32.9427852,27.1103124 L32.5175175,27.3016666 L32.5175175,21.4621434 L32.5175175,15.6226203 L32.9427852,15.8137445 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004256",
    d: "M35.3889609,19.555411 C35.7957679,19.6628261 36.0810811,20.0485016 36.0810811,20.4911255 L36.0810811,21.4622592 L36.0810811,22.4333928 C36.0810811,22.8757853 35.7957679,23.2614608 35.3889609,23.3688758 L33.705372,23.8131203 L33.705372,21.4622592 L33.705372,19.1111666 L35.3889609,19.555411 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#D3DEE4",
    points: "34.893 23.51 33.705 26.088 33.705 23.822"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "furia-travel-d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#furia-travel-c"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B6C0C7",
    points: "31.924 27.302 32.518 27.302 32.518 15.623 31.924 15.623",
    mask: "url(#furia-travel-d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004256",
    d: "M4.00900901,27.3016666 L4.00900901,27.3016666 L4.00900901,15.6226203 L4.00900901,15.6226203 C5.1570951,15.6226203 6.08775442,16.5639818 6.08775442,17.7249866 L6.08775442,25.1995302 C6.08775442,26.3605351 5.1570951,27.3016666 4.00900901,27.3016666",
    mask: "url(#furia-travel-d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF7FD",
    d: "M3.13829585,15.8137445 C2.76566571,15.9811795 2.52419086,16.3654978 2.52419086,16.7905249 L2.52419086,21.4621434 L2.52419086,26.1337619 C2.52419086,26.5587891 2.76566571,26.9428774 3.13829585,27.1103124 L3.56356356,27.3016666 L3.56356356,21.4621434 L3.56356356,15.6226203 L3.13829585,15.8137445 Z",
    mask: "url(#furia-travel-d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004256",
    d: "M0.692120164,19.555411 C0.28531316,19.6628261 0,20.0485016 0,20.4911255 L0,21.4622592 L0,22.4333928 C0,22.8757853 0.28531316,23.2614608 0.692120164,23.3688758 L2.37570904,23.8131203 L2.37570904,21.4622592 L2.37570904,19.1111666 L0.692120164,19.555411 Z",
    mask: "url(#furia-travel-d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#D3DEE4",
    points: "1.188 23.51 2.376 26.088 2.376 23.822",
    mask: "url(#furia-travel-d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B6C0C7",
    points: "3.415 27.302 4.009 27.302 4.009 15.623 3.415 15.623",
    mask: "url(#furia-travel-d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004256",
    d: "M35.0417084,20.4762499 L33.5373561,20.4762499 L33.5373561,15.3074021 C33.5373561,7.65282353 28.5169184,3.93193408 18.189135,3.93193408 C7.86112633,3.93193408 2.84068857,7.65282353 2.84068857,15.3074021 L2.84068857,20.4762499 L1.33633634,20.4762499 L1.33633634,15.3074021 C1.33633634,7.06664656 6.75763443,1.66843518 17.9402863,1.66843518 C29.1229381,1.66843518 35.0417084,7.06664656 35.0417084,15.3074021 L35.0417084,20.4762499 Z",
    mask: "url(#furia-travel-d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004256",
    d: "M19.0056723,0.455027776 C15.8172564,0.455027776 11.9227099,0.823412267 8.90890891,2.62881581 C9.3625921,3.27793942 10.3110178,4.04666244 12.1029649,3.38909384 C13.4619841,2.8903825 15.1129307,2.59184042 16.4595418,2.41632142 C18.1443285,2.19675148 19.8670162,2.19675148 21.5518029,2.41632142 C22.898414,2.59184042 24.5493606,2.8903825 25.9083798,3.38909384 C27.7003268,4.04666244 28.6487526,3.27793942 29.1024358,2.62881581 C26.0886348,0.823412267 22.1940883,0.455027776 19.0056723,0.455027776",
    mask: "url(#furia-travel-d)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.673
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.5,
    cy: 45,
    fill: "url(#furia-travel-e)",
    opacity: 0.142,
    rx: 44.5,
    ry: 45
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.5,
    cy: 45,
    fill: "url(#furia-travel-f)",
    rx: 44.5,
    ry: 45
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.5,
    cy: 45,
    fill: "url(#furia-travel-g)",
    stroke: "#DEDEDE",
    rx: 44.5,
    ry: 45
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFuriaTravel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/furia-travel.568b3d24.svg";
export { ForwardRef as ReactComponent };